export default __webpack_public_path__ + "static/media/use_action_back_cz.bbd52a16.png";